<template>
  <div class="ad-env-config-page">
    <el-card shadow="hover">
      <!-- 搜索栏 -->
      <div class="toolbar" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;">
        <div style="display:flex;align-items:center;">
          <span style="margin-right:8px;">类型：</span>
          <el-input
            v-model="searchForm.type"
            placeholder="请输入类型"
            clearable
            style="width:200px;"
            @keyup.enter.native="fetchConfigs"
          />
        </div>
        <div>
          <el-button type="primary" @click="openTypeListDialog">创建结构体</el-button>
          <el-button type="success" style="margin-left:10px;" @click="openCreateConfigDialog">
            创建配置
          </el-button>
        </div>
      </div>

      <!-- 配置列表 -->
      <el-table v-loading="loading" :data="configList" border>
        <el-table-column prop="type_text" label="类型" />
        <el-table-column label="配置内容" min-width="150">
          <template slot-scope="{ row }">
            <div v-for="(val, key) in row.config" :key="key">
              <strong>{{ key }}：</strong>{{ val }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.status"
              :active-value="1"
              :inactive-value="2"
              active-text="启用"
              inactive-text="禁用"
              @change="changeStatus(row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="updated_at_text" label="更新时间" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openUpdateConfigDialog(scope.row)">更新</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div style="text-align:right;margin-top:15px;">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :page-size="pagination.page_size"
          :current-page.sync="pagination.page"
          :total="total"
          @current-change="fetchConfigs"
        />
      </div>
    </el-card>

    <!-- ✅ 更新配置弹窗 -->
    <el-dialog title="更新配置" :visible.sync="updateDialogVisible" width="600px">
      <el-form label-width="120px">
        <el-form-item v-for="(val, key) in updateForm.config" :key="key" :label="key">
          <el-input v-model="updateForm.config[key]" placeholder="请输入值" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="updateDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpdateConfig">确认</el-button>
      </span>
    </el-dialog>

    <!-- ✅ 创建配置弹窗 -->
    <el-dialog title="创建配置" :visible.sync="createDialogVisible" width="650px">
      <el-form label-width="120px">
        <el-form-item label="类型">
          <el-select v-model="createForm.type" placeholder="请选择类型" @change="handleSelectType">
            <el-option
              v-for="item in typeListData"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <template v-if="Object.keys(createForm.fields).length">
          <el-form-item
            v-for="(val, key) in createForm.fields"
            :key="key"
            :label="key"
          >
            <el-input v-model="createForm.fields[key]" placeholder="请输入值" />
          </el-form-item>
        </template>

        <div v-if="!Object.keys(createForm.fields).length && createForm.type" style="color:#999;">暂无字段</div>
      </el-form>
      <span slot="footer">
        <el-button @click="createDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCreateConfig">创建</el-button>
      </span>
    </el-dialog>

    <!-- ✅ 结构体列表弹窗 -->
    <el-dialog title="结构体列表" :visible.sync="typeDialogVisible" width="700px">
      <el-table :data="typeListData" border>
        <el-table-column prop="value" label="场景名称" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleTypeSelect(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="typeDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- ✅ 结构体详情弹窗 -->
    <el-dialog :title="selectedTypeName" :visible.sync="detailDialogVisible" width="600px">
      <div v-loading="detailLoading">
        <div v-if="!detailStruct.length" style="color:#999;margin-bottom:10px;">
          暂无字段，点击按钮添加字段。
        </div>

        <el-form label-width="120px">
          <el-form-item
            v-for="(field, index) in detailStruct"
            :key="index"
            :label="'字段' + (index + 1)"
          >
            <el-input v-model="detailStruct[index]" style="width:250px;margin-right:15px" />
            <el-button type="text" @click="removeStructField(index)">删除</el-button>
          </el-form-item>
        </el-form>

        <div style="text-align:right;">
          <el-button type="primary" @click="addStructField">新增字段</el-button>
        </div>

        <div style="text-align:right;margin-top:10px;">
          <el-button @click="detailDialogVisible = false">取消</el-button>
          <!-- ✅ 判断逻辑修改：struct为空 -> 创建 -->
          <el-button v-if="!isUpdateStruct" type="success" @click="createStruct">创建</el-button>
          <el-button v-else type="primary" @click="updateStruct">更新</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  configsList,
  createConfig,
  updateConfig,
  typeList,
  vsDetail,
  vsCreate,
  vsUpdate
} from '@/api/adEnvConfig'

export default {
  name: 'AdEnvConfig',
  data() {
    return {
      searchForm: { type: '' },
      configList: [],
      total: 0,
      pagination: { page: 1, page_size: 10 },
      loading: false,

      // 更新配置
      updateDialogVisible: false,
      updateForm: { id: '', config: {}},

      // 创建配置
      createDialogVisible: false,
      createForm: { type: '', fields: {}},

      // 结构体管理
      typeDialogVisible: false,
      typeListData: [],
      detailDialogVisible: false,
      detailLoading: false,
      detailStruct: [],
      selectedTypeKey: null,
      selectedTypeName: '',
      isUpdateStruct: false // ✅ true = 更新, false = 创建
    }
  },
  created() {
    this.fetchConfigs()
  },
  methods: {
    /** 获取配置列表 */
    async fetchConfigs() {
      this.loading = true
      try {
        const res = await configsList({
          page: this.pagination.page,
          page_size: this.pagination.page_size,
          type: this.searchForm.type || undefined
        })
        if (res.code === 0 && res.data) {
          this.configList = res.data.list || []
          this.total = res.data.total || 0
        }
      } catch {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },

    /** 状态切换 */
    async changeStatus(row) {
      try {
        const res = await updateConfig({ id: row.id, status: row.status })
        if (res.code === 0) this.$message.success('状态更新成功')
        else this.$message.error('状态更新失败')
      } catch {
        this.$message.error('状态更新失败')
      }
    },

    /** 打开更新配置弹窗 */
    openUpdateConfigDialog(row) {
      this.updateForm = { id: row.id, config: { ...row.config }}
      this.updateDialogVisible = true
    },
    async submitUpdateConfig() {
      const res = await updateConfig({
        id: this.updateForm.id,
        config: this.updateForm.config
      })
      if (res.code === 0) {
        this.$message.success('更新成功')
        this.updateDialogVisible = false
        this.fetchConfigs()
      }
    },

    /** 创建配置 */
    async openCreateConfigDialog() {
      this.createDialogVisible = true
      this.createForm = { type: '', fields: {}}
      const res = await typeList()
      if (res.code === 0 && res.data) {
        this.typeListData = res.data.list
      }
    },
    async handleSelectType(typeKey) {
      const res = await vsDetail({ type: typeKey })
      const structArr = res.data?.config_struct?.struct || []
      const fields = {}
      structArr.forEach((k) => {
        fields[k] = ''
      })
      this.createForm.fields = fields
    },
    async submitCreateConfig() {
      const config = { ...this.createForm.fields }
      const res = await createConfig({ type: this.createForm.type, config })
      if (res.code === 0) {
        this.$message.success('创建成功')
        this.createDialogVisible = false
        this.fetchConfigs()
      }
    },

    /** 打开结构体列表 */
    async openTypeListDialog() {
      this.typeDialogVisible = true
      const res = await typeList()
      if (res.code === 0 && res.data) {
        this.typeListData = res.data.list
      }
    },

    /** 选择结构体类型 ✅ 修复逻辑：struct为空即创建 */
    async handleTypeSelect(row) {
      this.selectedTypeKey = row.key
      this.selectedTypeName = row.value
      this.detailDialogVisible = true
      this.detailLoading = true

      try {
        const res = await vsDetail({ type: row.key })
        const configStruct = res.data?.config_struct
        const structArr = configStruct?.struct || []

        this.detailStruct = Array.isArray(structArr) ? structArr : []

        // ✅ struct为空则标记为创建模式
        this.isUpdateStruct = this.detailStruct.length > 0
      } finally {
        this.detailLoading = false
      }
    },

    addStructField() {
      this.detailStruct.push('')
    },
    removeStructField(index) {
      this.detailStruct.splice(index, 1)
    },

    async createStruct() {
      const res = await vsCreate({ type: this.selectedTypeKey, struct: this.detailStruct })
      if (res.code === 0) {
        this.$message.success('创建成功')
        this.detailDialogVisible = false
      }
    },

    async updateStruct() {
      const res = await vsUpdate({ type: this.selectedTypeKey, struct: this.detailStruct })
      if (res.code === 0) {
        this.$message.success('更新成功')
        this.detailDialogVisible = false
      }
    }
  }
}
</script>

<style scoped>
.ad-env-config-page {
  padding: 20px;
}
</style>
